import { useAtomValue } from "jotai";
import { useCallback } from "react";

import { config } from "shared/data";

import { appAtom } from "scmp-app/lib/app/atoms";

import { fetchBids } from "./apis";
import { AllowCountryList } from "./consts";

export const useFetchBids = (slot: googletag.Slot | null) => {
  const { isAllow } = useCheckGeo();

  const handleFetchBids = useCallback(async () => {
    if (!slot) return;

    // Check if country is allowed
    if (!isAllow) return;

    const isValidApsAdSlot = (slot: googletag.Slot) => slot.getSizes?.()?.some(s => s !== "fluid");
    if (isValidApsAdSlot(slot)) {
      const { result } = fetchBids([slot]);
      await result;
    }
  }, [slot, isAllow]);

  return {
    handleFetchBids,
  };
};

export const useCheckGeo = () => {
  const { navigatorInfo } = useAtomValue(appAtom);

  const enabled = config.advertisement.amazonPublisherService.geoCheckEnabled;

  if (!enabled) return { isAllow: true };

  const country = navigatorInfo?.country ?? "";
  const isAllow = AllowCountryList.has(country);
  return { isAllow };
};
